import moment from 'moment-timezone';
import {i18n} from 'src/i18n';
import GestorDocumentalService from 'src/modules/gestorDocumental/gestorDocumentalService';
import layoutActions from 'src/modules/layout/layoutActions';
import Errors from 'src/modules/shared/error/errors';
import {getHistory} from 'src/modules/history';
import Message from 'src/view/shared/message';
import gestorDocumentalListActions from '../list/gestorDocumentalListActions';

const prefix = 'GESTORDOCUMENTAL_FORM';

const gestorDocumentalFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: gestorDocumentalFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await GestorDocumentalService.find(id);
      }

      dispatch({
        type: gestorDocumentalFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: gestorDocumentalFormActions.INIT_ERROR,
      });

      getHistory().push('/gestor-documental');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: gestorDocumentalFormActions.CREATE_STARTED,
      });

      const createdItem = await GestorDocumentalService.create(values);

      dispatch({
        type: gestorDocumentalFormActions.CREATE_SUCCESS,
      });

      Message.success(i18n('entities.gestorDocumental.create.success'));

      // getHistory().push('/gestor-documental');

      dispatch(gestorDocumentalListActions.doFetchCurrentFilter());

      dispatch(
        layoutActions.doVisibleDrawer({
          drawerId: 'DrawerGestorDocumentalFormPage',
          drawerVisible: false,
          drawerChanged: moment().unix(),
          drawerUpdateComponent: null,
        }),
      );
      return createdItem;
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: gestorDocumentalFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: gestorDocumentalFormActions.UPDATE_STARTED,
      });

      const updatedItem = await GestorDocumentalService.update(id, values);

      dispatch({
        type: gestorDocumentalFormActions.UPDATE_SUCCESS,
      });

      Message.success(i18n('entities.gestorDocumental.update.success'));

      // getHistory().push('/gestor-documental');

      dispatch(gestorDocumentalListActions.doFetchCurrentFilter());

      dispatch(
        layoutActions.doVisibleDrawer({
          drawerId: 'DrawerGestorDocumentalFormPage',
          drawerVisible: false,
          drawerChanged: moment().unix(),
          drawerUpdateComponent: null,
        }),
      );

      return updatedItem;
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: gestorDocumentalFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default gestorDocumentalFormActions;
